module.exports = __webpack_public_path__ + "static/media/DSC_0178.0f440b75.jpg";